const turf = require('@turf/turf')
export default class Geo {
  static metersPerPixel(latitude, zoomLevel) {
    const EARTH_CIRCUMFERENCE = 40075016.686
    const latitudeRadians = (latitude * Math.PI) / 180
    return Math.abs((EARTH_CIRCUMFERENCE * Math.cos(latitudeRadians)) / Math.pow(2, zoomLevel + 8))
  }

  static pixelValue(latitude, meters, zoomLevel) {
    return meters / Geo.metersPerPixel(latitude, zoomLevel)
  }

  static metersToKilometers(meter) {
    return meter / 1000
  }

  static pointToPolygonCoords(previousPoint, point, leftWorkWidth, rightWorkWidth, twoAgoPoint) {
    const leftDistance = Geo.metersToKilometers(leftWorkWidth)
    const rightDistance = Geo.metersToKilometers(rightWorkWidth)
    const bearing = turf.bearing(previousPoint, point)

    const options = {
      units: 'kilometers',
    }

    let rightPreviousPoint = turf.destination(previousPoint, rightDistance, bearing + 90, options)
    let leftPreviousPoint = turf.destination(previousPoint, leftDistance, bearing - 90, options)
    const rightPoint = turf.destination(point, rightDistance, bearing + 90, options)
    const leftPoint = turf.destination(point, leftDistance, bearing - 90, options)

    // 3点目以降は前ポリゴンと繋げる
    if (twoAgoPoint) {
      const previousBearing = turf.bearing(twoAgoPoint, previousPoint)
      rightPreviousPoint = turf.destination(previousPoint, rightDistance, previousBearing + 90, options)
      leftPreviousPoint = turf.destination(previousPoint, leftDistance, previousBearing - 90, options)
    }

    // 各ポイントのセンターを取得し、角度を計算して並べ替え（北西から左回り順）
    const points = turf.points([
      turf.getCoord(rightPreviousPoint),
      turf.getCoord(leftPreviousPoint),
      turf.getCoord(leftPoint),
      turf.getCoord(rightPoint),
    ])

    const center = turf.center(points)

    let pointsLists = [
      { data: rightPreviousPoint, bearing: turf.bearing(center, turf.getCoord(rightPreviousPoint)) },
      { data: leftPreviousPoint, bearing: turf.bearing(center, turf.getCoord(leftPreviousPoint)) },
      { data: leftPoint, bearing: turf.bearing(center, turf.getCoord(leftPoint)) },
      { data: rightPoint, bearing: turf.bearing(center, turf.getCoord(rightPoint)) },
    ]

    pointsLists.sort(function(a, b) {
      if (a.bearing > b.bearing) {
        return 1
      } else {
        return -1
      }
    })

    const polygon = turf.polygon([
      [
        turf.getCoord(pointsLists[0].data),
        turf.getCoord(pointsLists[1].data),
        turf.getCoord(pointsLists[2].data),
        turf.getCoord(pointsLists[3].data),
        turf.getCoord(pointsLists[0].data),
      ],
    ])

    const coords = turf.getCoords(polygon)
    return coords
  }

  //MultiPolygonは始点と終点が同じじゃないとGoogleMapで正しく認識されないため、始点と終点が同じじゃない場合は始点を最後に追加する
  static add0Point(coordinates) {
    coordinates.forEach(polygon => {
      polygon.forEach(points => {
        let point0 = null
        let listPoint0 = []

        for (let i = 0; i < points.length; i++) {
          const point = points[i]
          if (point0 === null) {
            listPoint0.push(point[0])
            listPoint0.push(point[1])
            listPoint0.push(point[2])
            point0 = listPoint0
          }
        }

        if (point0[0] !== points[points.length - 1][0] && point0[1] !== points[points.length - 1][1]) {
          points.push(point0)
        }
      })
    })
  }
}
